<template>
  <el-form
    :model="value"
    :rules="rules"
    ref="form"
    :label-width="labelWidth"
    class="contact-form"
  >
    <el-form-item v-if="!isShop" label="公司名称" prop="companyName">
      <el-input :disabled="disabledInfo" v-model="value.companyName"></el-input>
    </el-form-item>
    <el-form-item v-if="!isShop" label="联系人名称" prop="contact">
      <el-input :disabled="disabledInfo" v-model="value.contact"></el-input>
    </el-form-item>
    <el-form-item v-if="!hideWx" label="联系人微信" prop="wx">
      <el-input :disabled="disabledInfo" v-model="value.wx"></el-input>
    </el-form-item>
    <el-form-item label="联系人手机" prop="phone">
      <div><el-input :disabled="disabledInfo" v-model="value.phone"></el-input></div>
      <div class="tips"><span>此手机号会展示给合作商</span></div>
    </el-form-item>
    <el-form-item label="图片验证码" prop="imgCode">
      <div class="imgcode-wrp">
        <el-input class="imgcode-input" v-model="value.imgCode"></el-input>
        <el-image
          style="width: 82px; height: 28px"
          :src="pic"
          class="img-valid"
          @click="getPic"
          fit="contain"></el-image>
      </div>
    </el-form-item>
    <el-form-item label="短信验证码" prop="verifyCode">
      <el-input class="verifycode-input" v-model="value.verifyCode"></el-input>
      <el-button :disabled="!value.imgCode || this.telCodeCD" @click="getTelCode">{{telCodeCD ? `已发送${telCodeCDNum}s` : "获取验证码"}}</el-button>
    </el-form-item>
    <slot name="btn"></slot>
  </el-form>
</template>
<script>

import {getValiCodePicSrc, getTelValiCode} from '@pages/login/servers.js';
export default {
    props: {
      labelWidth: {
        type: String,
        default: '100px'
      },
      disabledInfo: {
        type: Boolean,
        default: false
      },
      isShop: {
        type: Boolean,
        default: false
      },
      hideWx: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      this.getPic();
    },
    computed: {
    },
    data() {
        return {
            pic: '',
            value: {
              companyName: '',
              contact: '',
              wx: '',
              phone: '',
              imgCode: '',
              verifyCode: ''
            },
            rules: {
                companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'change' },
                ],
                contact: [
                    { required: true, message: '请输入联系人名称', trigger: 'change' },
                    { max: 256, message: '不允许超过256个字符', trigger: 'change' },
                ],
                wx: [
                  { max: 256, message: '不允许超过256个字符', trigger: 'change' }
                ],
                phone: [
                    { required: true, max: 256, message: '请输入联系人手机', trigger: 'change' },
                    { pattern: /^[0-9]*$/, message: '手机号必须是数字', trigger: 'change' },
                    { len: 11, message: '手机号必须是11位', trigger: 'change' },
                ],
                imgCode: [
                    { required: true, message: '请输入图片验证码', trigger: 'blur' }
                ],
                verifyCode: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' }
                ],
          },
          telCodeCD: false,
          telCodeCDNum: 60,
          timmer: null
        }
    },
    methods: {
      async getPic() {
        const src = await getValiCodePicSrc('f');
        if (src) {
          this.pic = src;
        }
      },
      async getTelCode() {
        if (!this.value.imgCode) return this.$message.warning('请填写图片验证码');
        const res = await getTelValiCode({
            phoneNum: this.value.phone,
            validationCode: this.value.imgCode,
            status: 2
          });
        if (res) {
          this.setupTelCodeCD();
        } else {
          this.getPic();
        }
      },
      updateValue(val, isClearCode) {
        this.value.contact = val.contact;
        this.value.companyName = val.companyName;
        this.value.wx = val.wx;
        this.value.phone = val.phone;
        if (isClearCode) {
          this.value.imgCode = '';
          this.value.verifyCode = '';
        }
      },
      validate(cb) {
        this.$refs.form.validate(cb);
      },
      setupTelCodeCD() {
        this.telCodeCD = true
        this.timmer = setInterval(() => {
          this.telCodeCDNum--
          if (this.telCodeCDNum < 1){
            this.clearTelCodeCD()
          }
        }, 1000)
      },
      clearTelCodeCD() {
        this.telCodeCD = false
        this.telCodeCDNum = 60
        this.timmer && clearInterval(this.timmer)
        this.timmer = null
      },
      clearImgCode(isClearCode) {
        this.value.imgCode = '';
        if (isClearCode) {
          this.value.verifyCode = '';
        }
        this.getPic();
      },
      resetFields() {
        this.$refs.form.resetFields();
      },
      getFormData() {
        return this.value;
      }
    }
};
</script>

<style lang="scss">
.contact-form  {
  .verifycode-input {
    width: 228px;
    margin-right: 10px;
  }
  .imgcode-wrp {
    display: flex;
    .el-image {
      cursor: pointer;
    }
  }
  .img-valid {
    cursor: pointer;
  }
  .imgcode-input {
    width: 228px;
    margin-right: 10px;
  }
  .eidt-wrp {
    margin-top: 30px;
    button {
      display: block;
      margin-left: 110px;
    }
  }
  .tips {
    color: #999;
    text-align: left;
    font-size: 12px;
  }
}
</style>